import { lazily } from '@mk/core'
import { ContentLayout } from '@/features/layout/ContentLayout'

const { StaffMgmt } = lazily(() => import('@/features/staff'))
const { NavMgmt } = lazily(() => import('@/features/nav'))
const { DeptMgmt } = lazily(() => import('@/features/dept'))
const { Application } = lazily(() => import('@/features/application'))
const { Permission } = lazily(() => import('@/features/permission'))
/**
 * 系统基础路由
 */
export default [
  {
    id: Symbol('org'),
    path: '/org',
    element: <ContentLayout />,
    children: [
      {
        id: Symbol('org-staff'),
        path: 'staff',
        handle: {
          code: 'org-staff'
        },
        element: <StaffMgmt />
      },
      {
        id: Symbol('org-app'),
        path: 'app',
        handle: {
          code: 'org-app'
        },
        element: <Application />
      },
      {
        id: Symbol('org-nav'),
        path: 'nav',
        element: <NavMgmt />,
        handle: {
          code: 'org-nav'
        }
      },
      {
        id: Symbol('org-permission'),
        path: 'permission',
        handle: {
          code: 'org-permission'
        },
        element: <Permission />
      },
      {
        id: Symbol('org-dept'),
        path: 'dept',
        handle: {
          code: 'org-dept'
        },
        element: <DeptMgmt />
      }
    ]
  }
]
